import { makeRequest } from 'utils/requestLogger';

export default (id, payload) =>
  makeRequest('put', `/api/courses/${id}`, payload);



// WEBPACK FOOTER //
// ./src/app/services/courses/updateCourse.js